module.exports = __webpack_public_path__ + "media/images/vb_logo_full_color-1754f58b75966b6ec77af9769e841864.png";